import React, { PureComponent } from 'react'

class WindowScrollSink extends PureComponent {
  componentDidUpdate (prevProps) {
    if (prevProps.scrollLeft !== this.props.scrollLeft) {
      this.props.el.scrollLeft = this.props.scrollLeft
      //document.scrollingElement.scrollLeft = this.props.scrollLeft
    }
  }

  render () {
    return null
  }
}

export default WindowScrollSink;



// WEBPACK FOOTER //
// ./src/views/HomeView/WindowScrollSink.js